import SectionHeader from "../components/SectionHeader";
import ReviewCard from "../components/ReviewCard";
import CTASection from "../components/CTASection";
import { REVIEWS } from "../lib/business";

export default function ReviewsPage() {
  return (
    <div data-testid="reviews-page">
      <section className="bg-secondary/60 border-b border-border">
        <div className="container-x py-14 sm:py-20">
          <SectionHeader
            eyebrow="Reviews"
            title="5-Star Reviews From Local Customers"
            subtitle="Real feedback from customers who booked Abid Home Solutions through Thumbtack and other local service platforms."
          />
        </div>
      </section>
      <section className="section-y">
        <div className="container-x">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {REVIEWS.map((r, i) => (
              <ReviewCard key={i} review={r} index={i} />
            ))}
          </div>
        </div>
      </section>
      <CTASection
        title="Have we helped with a project?"
        subtitle="Leave us a review or refer us to a friend — it means the world to a local business."
      />
    </div>
  );
}
